/* eslint @typescript-eslint/naming-convention: 0 */
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface VideoCtaClickParams {
  section_id: string;
  video_id: string;
  position: number;
  screen_name: string;
  path: string;
}

export const sendGAWabunkaVideoCtaClickEvent = (params: { sectionId: string; videoId: string; position: number; screenName: string; path: string }) => {
  sendWabunkaGAEvent('video_cta_click', {
    section_id: params.sectionId,
    video_id: params.videoId,
    position: params.position,
    screen_name: params.screenName,
    path: params.path,
  });
};
